import { Raglan } from "./raglan";

export class Rundfelling {
  parts() {
    const _parts = new Raglan().parts();
    _parts.forEach((part: any) => (part.circularYoke = true));
    return _parts;
  }
}
